import { useEffect, useState } from 'react'
import { getCountdown } from 'utils/dates'

type Countdown = {
  days: string
  hrs: string
  min: string
  sec: string
}

const initialCountdown: Countdown = {
  days: '00',
  hrs: '00',
  min: '00',
  sec: '00',
}

export function useCountdown(target: Date | undefined | null) {
  const [countdown, setCountdown] = useState<Countdown>(() => {
    // calling getCountdown(target) would result in a hydration error because the value on the client changes
    return initialCountdown
  })

  useEffect(() => {
    if (!target) return

    const timer = setTimeout(() => {
      const diff = target.getTime() - new Date().getTime()

      if (diff <= 0) {
        setCountdown(initialCountdown)
        return
      }

      setCountdown(getCountdown(target))
    }, 1000)

    return () => {
      clearTimeout(timer)
    }
  }, [countdown, target])

  return countdown
}
